import React, { useState } from 'react';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { selectAllLevels } from '../../data/levelsSlice'
import { selectAllCategories } from '../../data/categoriesSlice'
import { selectCurrentLangId } from '../languages/languagesSlice'
import './LevelSelection.css'

const root = process.env.PUBLIC_URL

const LevelSelection = () => {
  const currLangId = useSelector(selectCurrentLangId)
  const levels = useSelector(selectAllLevels)
  const categories = useSelector(selectAllCategories)
  const [isDragging, setIsDragging] = useState(false)
  const [draggingPos, setDraggingPos] = useState({ top: 0, left: 0, x: 0, y: 0 })
  const [currentCategory, setCurrentCategory] = useState(0)
  const refCategories = React.createRef()

  const handleMouseUp = e => {
    setIsDragging(false)
  }
  const handleMouseDown = e => {
    let pos = {
      top: refCategories.current.scrollTop,
      left: refCategories.current.scrollLeft,
      x: e.clientX,
      y: e.clientY
    }
    setDraggingPos(pos)
    setIsDragging(true)
  }
  const handleMouseMove = e => {
    if (isDragging) {
      const dx = e.clientX - draggingPos.x
      const dy = e.clientY - draggingPos.y
      refCategories.current.scrollTop = draggingPos.top - dy
      refCategories.current.scrollLeft = draggingPos.left - dx
    }
  }

  const handleClick__CategoryTag = categoryId => {
    if (!isDragging) {
      setCurrentCategory(categoryId)
    }
  }

  const renderedCatetoryTags = [{
    id: 0,
    vi: "Tất Cả",
    en: "All",
    tw: "全部",
    cn: "全部"
  }, ...categories].map(category => (
    <button
      key={category.id}
      className={`btn ${currentCategory === category.id ? 'active' : ''}`}
      onClick={() => handleClick__CategoryTag(category.id)}
    >
      {category[currLangId]}
    </button>
  ))

  const renderedLevelCards = levels
    .filter(level => {
      if (currentCategory === 0) return true
      if (currentCategory === level.category) return true
      return false
    })
    .sort((a, b) => a.id > b.id ? -1 : 1)
    .map(level => {
      const src = `${root}/assets/game/img/levels/${level.folder}/thumbnail.png`
      return (
        <Link to={`${root}/game/${level.id}`} key={level.id} >
          <img src={src} />
        </Link>
      )
    })

  return (
    <section className="container">
      <h1>Select a Level</h1>
      <div
        className="categories"
        ref={refCategories}
        onMouseUp={handleMouseUp}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseUp}
      >
        {renderedCatetoryTags}
      </div>
      <div className="level-cards">
        {renderedLevelCards}
      </div>
    </section>
  )
}

export default LevelSelection